import React from "react";
import GenericCrudPage from "../../components/shared/GenericCrudPage";
import {
  adminGetProductCategories, adminCreateProductCategory, adminUpdateProductCategory,
} from "../../api/business";

export default function ProductCategoriesPage() {
  return (
    <GenericCrudPage
      title="Product Categories"
      queryKey="admin-product-categories"
      listFn={adminGetProductCategories}
      createFn={adminCreateProductCategory}
      updateFn={adminUpdateProductCategory}
      emptyItem={{ name: "", slug: "" }}
      columns={[
        { key: "name", label: "Name" },
        { key: "slug", label: "Slug" },
      ]}
      formFields={[
        { name: "name", label: "Name", required: true },
        { name: "slug", label: "Slug", required: true },
      ]}
    />
  );
}